import * as React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { UnitSystem } from '@/lib/calculator';

interface UnitToggleProps {
  value: UnitSystem;
  onChange: (unit: UnitSystem) => void;
}

export function UnitToggle({ value, onChange }: UnitToggleProps) {
  return (
    <div className="flex items-center justify-center" role="radiogroup" aria-label="Unit system">
      <div className="inline-flex rounded-lg bg-muted p-1">
        <button
          type="button"
          role="radio"
          aria-checked={value === 'imperial'}
          onClick={() => onChange('imperial')}
          className={cn(
            "relative px-4 py-2 text-sm font-medium rounded-md transition-colors",
            value === 'imperial' 
              ? "text-foreground" 
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {value === 'imperial' && (
            <motion.div
              layoutId="unit-indicator"
              className="absolute inset-0 bg-background rounded-md shadow-sm"
              transition={{ type: "spring", bounce: 0.2, duration: 0.4 }}
            />
          )}
          <span className="relative z-10">Imperial (ft)</span>
        </button>
        <button
          type="button"
          role="radio"
          aria-checked={value === 'metric'}
          onClick={() => onChange('metric')}
          className={cn(
            "relative px-4 py-2 text-sm font-medium rounded-md transition-colors",
            value === 'metric' 
              ? "text-foreground" 
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {value === 'metric' && (
            <motion.div
              layoutId="unit-indicator"
              className="absolute inset-0 bg-background rounded-md shadow-sm"
              transition={{ type: "spring", bounce: 0.2, duration: 0.4 }}
            />
          )}
          <span className="relative z-10">Metric (m)</span>
        </button>
      </div>
    </div>
  );
}
